import React from 'react';


export default class ViewerCount extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      viewers: -1
    };

    this.update = this.update.bind(this);
  }

  componentDidMount() {
    if (this.props.video) {
      this.props.video.addEventListener('viewers', this.update);
    }
  }

  componentWillUnmount() {
    if (this.props.video) {
      this.props.video.removeEventListener('viewers', this.update);
    }
  }

  update() {
    if (!this.props.video.viewers) return;
    this.setState({viewers: this.props.video.viewers.current});
  }

  get viewerCount() {
    const { viewers } = this.state;
    if (viewers < 1000) return viewers;
    let unit;
    let str;
    if (viewers < 1000000) {
      str = (viewers / 1000) + '';
      unit = 'k';
    } else {
      str = (viewers / 1000000) + '';
      unit = 'M';
    }
    const periodAt = str.indexOf('.');

    if (periodAt === -1) return str + unit; // No decimals

    if (str.charAt(periodAt + 1) === '0') return str.substr(0, periodAt) + unit; // First decimal is zero: omit it

    return str.substr(0, periodAt + 2) + unit; // Include one decimal
  }

  render() {
    if (this.state.viewers < 0) return null;
    return (
      <div className='viewer-count'>
        {this.viewerCount}
      </div>
    );
  }
}
